var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M0 0h12v2H0zM0 4h12v2H0zM0 8h12v2H0z"})));
}

Menu.defaultProps = {"width":"12","height":"10"};

module.exports = Menu;

Menu.default = Menu;
